import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * Zendesk Create Ticket v4 Configuration Validator
 * Validates Zendesk ticket creation configuration with newUser support
 */
const zendeskFollowerSchema = z
    .object({
    user_id: z.string().optional(),
    user_email: z.string().email().optional()
})
    .refine((data) => data.user_id || data.user_email, {
    message: 'Either User ID or User Email must be provided'
});
export const Zendesk_Create_Ticket_4_ConfigValidator = z
    .object({
    zendeskConnection: requiredString('Zendesk Connection is required'),
    subject: requiredString('Ticket Subject is required'),
    description: requiredString('Ticket Description is required'),
    requesterName: z.string().optional(),
    requesterEmail: z.string().optional(),
    requesterPhone: z.string().optional(),
    brandId: z.string().optional(),
    assigneeId: z.string().optional(),
    groupId: z.string().optional(),
    ticketFormId: z.string().optional(),
    status: z.enum(['new', 'open', 'pending', 'hold', 'solved', 'closed']).nullable().optional(),
    newUser: z.boolean().default(false),
    viaId: z.number().optional(),
    customFields: z.record(z.string(), z.any()).optional(),
    followers: z.array(zendeskFollowerSchema).optional()
})
    .refine((data) => {
    // requesterName is required when requesterEmail or requesterPhone is provided
    if ((data.requesterEmail || data.requesterPhone) && !data.requesterName) {
        return false;
    }
    return true;
}, {
    message: 'requesterName is required when requesterEmail or requesterPhone is provided',
    path: ['requesterName']
});
//# sourceMappingURL=zendesk-create-ticket-4.js.map